import { scCoreModule } from '../core/core.module';
import { HddUsageModalService } from './hdd-usage-modal.service';

export const scAdminModule = 'sc-admin';

angular.module(scAdminModule, [scCoreModule])
  .service('HddUsageModalService', HddUsageModalService)
;



// WEBPACK FOOTER //
// ./src/admin/admin.module.js